import { Controller } from "@hotwired/stimulus"

// Toggle truncated summaries on game cards / admin lists.
export default class extends Controller {
  static targets = ["short", "full", "button"]

  toggle(event) {
    event.preventDefault()
    const expanding = this.shortTarget.hidden === false

    this.shortTarget.hidden = expanding
    this.fullTarget.hidden = !expanding
    this.buttonTarget.textContent = expanding ? "(read less)" : "(read more)"
    this.buttonTarget.setAttribute("aria-expanded", expanding ? "true" : "false")
  }
}
